import createNamespaceContext from './helper/createNamespaceContext';
export const AVP_CONTEXT = 'avpCtx';
export const AVPAnalyticsContext = createNamespaceContext(AVP_CONTEXT, 'AVPAnalyticsContext');